// The instutitional portal iframes this exchange passing ?type=institutional
// in the url. So we have this selector for when we need need to change the
// UI somehow for them.
export default (): boolean => {
  const query = new URLSearchParams(window.location.search)
  const exchangeType = query.get('type')
  return exchangeType === 'institutional'
}
